export enum EvaluationStatus {
  Draft = 0,
  InProgress = 2,
  Finished = 3,
}